import cashierApis from 'modules/POS/services/apis';
import { IEmailFuncType, ISignatureActionFunc, ISMSFuncType } from '../payments/Card/ModalCardPayment/RequestSignature';
import { removeBase64Prefix } from 'utils/removeBase64Prefix';
import { setPageLoading } from 'widgets/PageLoading';

const useSMSEmailSignature = () => {
  // const setLoadingPage = useSetLoadingPage();
  const onNoReceipt: (billId: string, cb: () => void) => ISignatureActionFunc = (billId, cb) => async (signatureValue, args) => {
    args.close();
    if (signatureValue) {
      setPageLoading(true);
      try {
        await cashierApis.updateSignature(billId || '', removeBase64Prefix(signatureValue));
      } catch (error) { }
      finally {
        setPageLoading(false);
      }
    }
    cb();
  };

  const onSMS: (billId: string, cb: () => void) => ISMSFuncType = (billId, cb) => async ({ signature, phone }, args) => {
    if (!signature || !phone) return;
    const signatureValue = removeBase64Prefix(signature);
    setPageLoading(true);
    try {
      await cashierApis.updateSignature(billId || '', signatureValue);
      await cashierApis.sendSMSEmailReceipt(billId || '', 'SMS', phone?.replace(/[^0-9]/g, ''));
      args.close();
      cb();
    } catch (error) { }
    finally {
      setPageLoading(false);
    }
  };

  const onEmail: (billId: string, cb: () => void) => IEmailFuncType = (billId, cb) => async ({ signature, email }, args) => {
    if (!signature || !email) return;
    const signatureValue = removeBase64Prefix(signature);
    setPageLoading(true);
    try {
      await cashierApis.updateSignature(billId || '', signatureValue);
      await cashierApis.sendSMSEmailReceipt(billId || '', 'EMAIL', email);
      args.close();
      cb();
    } catch (error) { }
    finally {
      setPageLoading(false);
    }
  };
  return ({
    onNoReceipt,
    onSMS,
    onEmail,
  });
};

export default useSMSEmailSignature;
